import { createReducer } from 'typesafe-actions';
import { CHANGE_TREE_TYPE } from '../actions';
import { TreeType } from '../types';

export const treeType = createReducer<TreeType>('NONE').handleAction(CHANGE_TREE_TYPE, (state, action) => action.payload);